enum ProofOfPlayType {
	ItemPlayed = 'PoP.ItemPlayed',
}

export default ProofOfPlayType;
